import { RefString, RefDate } from "@tblabs/truffle";
import { InvoiceStepRawData } from "./InvoiceStepRawData";
import { InvoiceStepState } from "./InvoiceStepState";
import { StepData } from "../../Step/StepData";


export class InvoiceStepData extends StepData
{
    public InvoiceNumber = new RefString("");
    public CompanyName = new RefString("");
    public CompanyAddress = new RefString("");
    public CompanyNIP = new RefString("");
    public CompanyEmail = new RefString("");
    public DeliveryDeadline = new RefDate(new Date(0));
    public SentAt = new RefDate(new Date(0));

    constructor(raw: Partial<InvoiceStepRawData>)
    {
        super(raw);

        this.State.value ||= InvoiceStepState.Preparing;

        this.InvoiceNumber.value = this.GetString(raw?.InvoiceNumber);
        this.CompanyName.value = this.GetString(raw?.CompanyName);
        this.CompanyAddress.value = this.GetString(raw?.CompanyAddress);
        this.CompanyNIP.value = this.GetString(raw?.CompanyNIP);
        this.CompanyEmail.value = this.GetString(raw?.CompanyEmail);
        this.DeliveryDeadline.value = this.GetDate(raw?.DeliveryDeadline);
        this.SentAt.value = this.GetDate(raw?.SentAt);
    }
}
